var React = require('react');

function DesignsystemiconInline (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M3 22.0909V23.6364C3 28.0546 6.58172 31.6364 11 31.6364H20.1818V41.1818C20.1818 43.2905 21.8913 45 24 45V45C26.1087 45 27.8182 43.2905 27.8182 41.1818V31.6364H37C41.4183 31.6364 45 28.0546 45 23.6364V22.0909M3 22.0909V7C3 4.79087 4.79086 3 7 3H29.7273M3 22.0909H45M45 22.0909V7C45 4.79086 43.2091 3 41 3H37.3636M29.7273 3V12.0682M29.7273 3H37.3636M37.3636 3V16.3636","stroke":"#FF6A3C","strokeWidth":"3","key":0}),React.createElement("path",{"d":"M46 42.5C46 44.433 44.433 46 42.5 46C40.567 46 39 44.433 39 42.5C39 40.567 42.5 36 42.5 36C42.5 36 46 40.567 46 42.5Z","fill":"#FF6A3C","stroke":"#FF6A3C","strokeWidth":"3","key":1})]);
}

DesignsystemiconInline.defaultProps = {"width":"48","height":"48","viewBox":"0 0 48 48","fill":"none"};

module.exports = DesignsystemiconInline;

DesignsystemiconInline.default = DesignsystemiconInline;
